import React from 'react';

function TypeBadge({ name }) {
    return (
        <span class="type-badge">{name}</span>
    );
}

export default TypeBadge;
